import { CustomerList } from "@/components/cms/e-shop/CustomerList";
import { OrderList } from "@/components/cms/e-shop/OrderList";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLastTimeNewOrdersChecked } from "@/context/OrderContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const EShopDashboard = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState<"orders" | "customers">("orders");
  const [search, setSearch] = useState<string | undefined>();

  const [searchParams, setSearchParam] = useSearchParams();

  const { setLastChecked } = useLastTimeNewOrdersChecked();

  useEffect(() => {
    const view = searchParams.get("view");

    if (view == null) return;
    if (view === "orders" || view === "customers") {
      setTabValue(view);
      return;
    }

    setTabValue("orders");
  }, [searchParams]);

  useEffect(() => {
    setLastChecked(new Date());
  }, [setLastChecked]);

  return (
    <>
      <Tabs
        className="px-6 py-4 flex flex-col gap-6"
        value={tabValue}
        onValueChange={(v) => setSearchParam({ view: v })}
      >
        <TabsList className="flex flex-1 flex-row items-center">
          <TabsTrigger value="orders">{t("sales")}</TabsTrigger>
          <TabsTrigger value="customers">{t("customers")}</TabsTrigger>
        </TabsList>
        <div className="flex-1">
          <Input
            placeholder={t("search")}
            onChange={(s) => setSearch(s.target.value)}
          />
        </div>
        {(() => {
          switch (tabValue) {
            case "orders":
              return <OrderList search={search} />;
            case "customers":
              return <CustomerList search={search} />;
          }
        })()}
      </Tabs>
    </>
  );
};
